import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from './../utils';
import { IInvoiceLineMovementsSearchResponse } from './interfaces';

export async function search(query: { DocumentNumber: number; LineNumber: number; Page?: number; Sort?: string; SortDirection?: string; BatchSize?: number }): Promise<IInvoiceLineMovementsSearchResponse> {
  const { DocumentNumber, LineNumber, Page, Sort, SortDirection, BatchSize = DEFAULT_PAGE_SIZE } = query;

  return fetchGet(`SupplierInvoiceEnquiry/SupplierInvoice/LineMovements/Invoices/${DocumentNumber}/Line/${LineNumber}`, { BatchPage: Page, BatchSize, Sort: Sort && SortDirection && `${Sort}:${SortDirection}` })
    .then((result) => result && result.SupplierInvoiceEnquiryLineMovements &&
      ({
        records: result.SupplierInvoiceEnquiryLineMovements.map((item) => objectify(item, null, 'Inline')),
        nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
        currPage: result.BatchInformation && result.BatchInformation.BatchPage,
      })
    );
}
